import * as ng from 'angular';
import { ComponentRegistration } from '../core';
let template = require('./phone.html');

class PhoneComponent extends ComponentRegistration {

    constructor() {
        super('phone', {
            controller: PhoneController,
            templateUrl: template,
            controllerAs: 'phone',
            bindings: {
                name: "@?",
                label: '@?',
                required: '=?',
                value: '=?',
                ngDisabled: "=?",
                form: "&?"
            }
        });
    }
}

interface IPhoneController {
    validate(): void;
    onChange(): void;
}

class PhoneController implements IPhoneController {
    private static $inject: Array<string> = [];

    //private fields
    private fieldName: string;
    private displayLabel: string;
    private isRequired: Boolean;
    private hostForm: ng.IFormController;
    private field: any;

    //bindings
    private name: string;
    private label: string;
    private required: Boolean;
    private value: string;
    private ngDisabled: Boolean;
    private form: Function;

    constructor() {
        console.log("phone controller loaded.");
 
    }

    public $onInit(): void {

        this.value = this.value || '';
        this.fieldName = this.name || 'phone';
        this.displayLabel = this.label || 'Phone';
        this.isRequired = this.required || false;
        this.ngDisabled = this.ngDisabled || false;

        this.assureForm();

        console.log("Phone controller activated.");
    }

    private assureForm(): void {
        this.hostForm = this.form();

        if (!this.hostForm) {
            throw "Form reference was not resolved by the execution of the expression.";
        }   
    }

    public validate(): void {
        let field = this.field = this.hostForm[this.fieldName] as any; 
    }

    public onChange(): void {
        this.validate();
    }

}

let phComponent = new PhoneComponent();
export default phComponent;
export { phComponent as PhoneComponent, IPhoneController, PhoneController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/phone.ts